import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import Collapse from 'antd/lib/collapse';
import PagesLayout from './PagesLayout';

const { Panel } = Collapse;

const MajakLink = ({ t }) => <Link to="/">{t('Majak.sk')}</Link>;
const MajakLinkT = translate()(MajakLink);

const MajakEmail = ({ t }) => <a href="mailto:info@majak.sk">{t('info@majak.sk')}</a>;
const MajakEmailT = translate()(MajakEmail);

const faqs = [
  {
    Header: ({ t }) => <span>{t('Kto môže investovať cez Majak.sk?')}</span>,
    Content: ({ t }) => (
      <p>{t('Investovať môže každý, kto má 18 a viac rokov, má občianstvo SR.')}</p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Kto si môže požičať cez Majak.sk?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'O pôžičku môže požiadať každý, kto má 18 a viac rokov, má občianstvo SR a úspešne splnil podmienky skóringu.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Prečo investovať cez Majak.sk?')}</span>,
    Content: ({ t }) => (
      <p>
        <MajakLinkT /> {t('ponúka omnoho vyššie výnosy ako sú úroky bankách.')} <MajakLinkT />{' '}
        {t(
          'spája investorov priamo s dlžníkmi, a to bez banky a jej podmiemok a cenníkov. Každá Investícia je viackrát zabezpečená. A aj keby nedošlo k splateniu celej investície,'
        )}{' '}
        <MajakLinkT /> {t('garantuje Investorovi uhradenie celej nesplatenej istiny.')}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Prečo si požičať cez Majak.sk?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Pretože máte nižší úrok ako v banke alebo tzv. nebankovke. Pretože ide o modernú a pohodlnú formu požičiavania si a všetko vybavíte rýchlo, pohodlne a cez internet. A, pretože, tu nie sú nekalé obchodné praktiky a ani neprijateľné zmluvné podmienky. Jednoducho, tu je to férové.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Aké sú úroky na Majak.sk?')}</span>,
    Content: ({ t }) => (
      <p>
        {t('Úroky na pôžičkách získaných cez')} <MajakLinkT />{' '}
        {t(
          'sú výrazne nižšie ako sú úroky pri spotrebiteľských úrokoch v bankách a v tzv. nebankovkách. Cez'
        )}{' '}
        <MajakLinkT />{' '}
        {t(
          'Vám požičiava priamo Investor. A to bez účasti banky, ktorá si účtuje množstvo poplatkov, ako napr. administratívny poplatok, poplatok za vedenie účtu a pod. A tieto poplatky pri pôžičkách uzatvorených cez'
        )}{' '}
        <MajakLinkT /> {t('odpadávajú.')}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Ako sa vyplácajú výnosy?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Výnosy si môžete nechať pripísať na Váš virtuálny účet a budete ich môcť opäť investovať. Môžete sa však rozhodnúť aj tak, že si výnosy necháte poslať na Váš účet vo Vašej banke. V tomto prípade však pre navýšenie zostatku na investovanie, budete musieť opäť previesť peniaze z Vášho účtu v banke na Váš virtuálny účet.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Ako mám splácať?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Splatnosť splátky je nastavená vždy k 15. dňu kalendárneho mesiaca. Vašu splátku posielate na bankový účet uvedený v dlžníckej rámcovej zmluve. Odporúčame Vám, z dôvodu Vášho komfortu nastaviť si na Vašom účte v banke trvalý príkaz na toľko opakovaní, koľko je dohodnutých splátok v zmluve o pôžičke a deň splatnosti na 12. deň v mesiaci. Tým predídete oneskorenie splátky, ak by náhodou deň, ktorý zadáte na realizáciu platby pripadol napr. na víkend.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Dá sa pôžička splatiť aj predčasne?')}</span>,
    Content: ({ t }) => (
      <p>
        {t('Áno, pôžička sa dá splatiť vždy aj predčasne, a to za podmienok dohodnutých v zmluve.')}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Aká je minimálna a maximálna suma pôžičky?')}</span>,
    Content: ({ t }) => (
      <p>{t('Minimálna suma pôžičky je 700€ a maximálna suma je neobmedzená.')}</p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Aká je minimálna a maximálna suma investície?')}</span>,
    Content: ({ t }) => (
      <p>{t('Minimálna suma Investície je 700€ a maximálna suma je neobmedzená.')}</p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Ako je moja investícia zabezpečená?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Vaša investícia je zabezpečená viacnásobne. Každý žiadateľ musí splniť prísne skóringové kritériá, aby mohol požiadať prostredníctvom'
        )}{' '}
        <MajakLinkT />{' '}
        {t(
          'o pôžičku. Ďalším zabezpečením je, že ak by aj došlo k nesplateniu čo i len časti pôžičky,'
        )}{' '}
        <MajakLinkT /> {t('garantuje Investorovi uhradenie celej nesplatenej istiny.')}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Aké doklady budem potrebovať pri investovaní?')}</span>,
    Content: ({ t }) => <p>{t('Pre investovanie budete potrebovať iba občiansky preukaz. ')}</p>,
  },
  {
    Header: ({ t }) => <span>{t('Aké doklady budem potrebovať pri pôžičke?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Pri pôžičke budete potrebovať občiansky preukaz a ďalší doklad, napr. vodičský preukaz alebo pas.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Ako si môžem vybrať výnos z investície?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Jednoducho, necháte si posielať výnos na virtuálny účet a tieto peniaze môžete opäť investovať alebo si výnos necháte poslať na Váš osobný účet vo Vašej banke.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Čo je to skóring klienta?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Skóring klienta je systém posudzovania schopnost dlžníka splácať pôžičku. Skóring má veľmi prísne pravidlá a požiadavky na dlžníkov, takže iba tí, ktorí splnia tieto náročné kritériá možu požiadať o pôžičku.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Pozná dlžník moje osobné údaje?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Nie, nepozná. Dlžník pozná iba číselný identifikátor, pod ktorým investor vystupuje. V prípáde, že by napr. vznikol súdny spor, bude môcť byť identita zmluvných strán odtajená.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Pozná investor moje osobné údaje?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Nie, nepozná. Investor pozná iba číselný identifikátor, pod ktorým vystupujete. V prípáde, že by napr. vznikol súdny spor, bude môcť byť identita zmluvných strán odtajená.'
        )}
      </p>
    ),
  },
  {
    Header: ({ t }) => <span>{t('Ako podať reklamáciu?')}</span>,
    Content: ({ t }) => (
      <p>
        {t(
          'Reklamáciu klient podáva písomne na adresu spoločnosti: Peer2Peer, s.r.o., Mostová 2, 811 02 Bratislava alebo elektronicky na e-mailovú adresu'
        )}{' '}
        <MajakEmailT />.<br />
        {t(
          'Z reklamácie musí byť zrejmé, kto reklamáciu podáva, čo je jej obsahom a čoho sa domáha. K reklamácii je priložiť doklady preukazujúce pravdivosť tvrdení klienta. Klient uplatňuje reklamáciu bezodkladne ako sa o vade jemu poskytovanej služby dozvedel.'
        )}
        <br />
        {t(
          'Lehota na vybavenie reklamácie je 30 dní od podania reklamácia a táto lehota začína plynúť dňom doručenia reklamácie. Spoločnosť vydá klientovi doklad o vybavení reklamácie najneskôr do 30 dní odo dňa uplatnenia reklamácie.'
        )}
      </p>
    ),
  },
];

const Faq = ({ t }) => (
  <PagesLayout noImg>
    <h2>{t('FAQ')}</h2>
    <Collapse bordered={false} accordion>
      {faqs.map(({ Header, Content }, idx) => (
        <Panel key={idx} header={<Header t={t} />}>
          <Content t={t} />
        </Panel>
      ))}
    </Collapse>
  </PagesLayout>
);

Faq.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(Faq);



// WEBPACK FOOTER //
// ./src/features/pages/Faq.js